/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardSeverityKpi
 */
export interface DashboardSeverityKpi {
  /**
   *
   * @type {number}
   * @memberof DashboardSeverityKpi
   */
  mean: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSeverityKpi
   */
  median: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSeverityKpi
   */
  q75: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSeverityKpi
   */
  q95: number;
  /**
   *
   * @type {number}
   * @memberof DashboardSeverityKpi
   */
  q100: number;
}

/**
 * Check if a given object implements the DashboardSeverityKpi interface.
 */
export function instanceOfDashboardSeverityKpi(value: object): value is DashboardSeverityKpi {
  if (!('mean' in value) || value['mean'] === undefined) return false;
  if (!('median' in value) || value['median'] === undefined) return false;
  if (!('q75' in value) || value['q75'] === undefined) return false;
  if (!('q95' in value) || value['q95'] === undefined) return false;
  if (!('q100' in value) || value['q100'] === undefined) return false;
  return true;
}

export function DashboardSeverityKpiFromJSON(json: any): DashboardSeverityKpi {
  return DashboardSeverityKpiFromJSONTyped(json, false);
}

export function DashboardSeverityKpiFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSeverityKpi {
  if (json == null) {
    return json;
  }
  return {
    mean: json['mean'],
    median: json['median'],
    q75: json['q75'],
    q95: json['q95'],
    q100: json['q100'],
  };
}

export function DashboardSeverityKpiToJSON(value?: DashboardSeverityKpi | null): any {
  if (value == null) {
    return value;
  }
  return {
    mean: value['mean'],
    median: value['median'],
    q75: value['q75'],
    q95: value['q95'],
    q100: value['q100'],
  };
}
